import { useEffect, useState } from "react";
import { CalendarCheck } from "lucide-react";
import { toast } from "sonner";
import { EmptyState, KehadiranBadge } from "../../components/common";
import { portalApi } from "../../lib/portalApi";
import { errMsg } from "../../lib/api";
import { fmtDate } from "../../lib/format";

export default function PortalRiwayat() {
  const [items, setItems] = useState(null);
  useEffect(() => { portalApi.get("/portal/kehadiran").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))); }, []);

  return (
    <div>
      <h2 className="mb-4 font-heading text-lg font-semibold text-gray-900">Riwayat kehadiran</h2>
      {items && items.length === 0 ? <EmptyState icon={CalendarCheck} title="Belum ada riwayat" desc="Riwayat check-in Anda akan muncul di sini." /> : (
        <div className="overflow-hidden rounded-xl border border-gray-200 bg-white" data-testid="portal-riwayat-list">
          {(items || []).map((k) => (
            <div key={k.id} data-testid={`portal-riwayat-${k.id}`} className="flex items-center justify-between gap-3 border-b border-gray-100 px-4 py-3 last:border-0">
              <div>
                <p className="font-semibold text-gray-900">{fmtDate(k.tanggal)}</p>
                <p className="font-mono text-sm text-gray-500">{k.jam} WIB</p>
              </div>
              <KehadiranBadge status={k.status} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
